var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgClientsLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 32,
    viewBox: "0 0 24 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-clients-link_svg__cls-2,.kpmg-clients-link_svg__cls-7{fill:none}.kpmg-clients-link_svg__cls-2{stroke:#fff;stroke-width:1.6px}.kpmg-clients-link_svg__cls-6{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-clients-link_svg__ICN_Clienti_KPMG_Active",
    "data-name": "ICN_Clienti KPMG_Active",
    transform: "translate(-119 -150)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-clients-link_svg__Rectangle_347",
    "data-name": "Rectangle 347",
    transform: "translate(119 176.006)",
    strokeWidth: 1.6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 5,
    className: "kpmg-clients-link_svg__cls-6",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.345,
    height: 3.4,
    x: 0.8,
    y: 0.8,
    className: "kpmg-clients-link_svg__cls-7",
    rx: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-clients-link_svg__Rectangle_348",
    className: "kpmg-clients-link_svg__cls-2",
    "data-name": "Rectangle 348",
    transform: "translate(121 161.214)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 13.731,
    className: "kpmg-clients-link_svg__cls-6",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 12.131,
    x: 0.8,
    y: 0.8,
    className: "kpmg-clients-link_svg__cls-7",
    rx: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-clients-link_svg__Rectangle_349",
    "data-name": "Rectangle 349",
    transform: "translate(127.973 161.214)",
    stroke: "#30acec",
    strokeWidth: 1.6,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 13.731,
    className: "kpmg-clients-link_svg__cls-6",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 12.131,
    x: 0.8,
    y: 0.8,
    className: "kpmg-clients-link_svg__cls-7",
    rx: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-clients-link_svg__Rectangle_350",
    className: "kpmg-clients-link_svg__cls-2",
    "data-name": "Rectangle 350",
    transform: "translate(134.945 161.214)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 13.731,
    className: "kpmg-clients-link_svg__cls-6",
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.4,
    height: 12.131,
    x: 0.8,
    y: 0.8,
    className: "kpmg-clients-link_svg__cls-7",
    rx: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-clients-link_svg__Path_894",
    "data-name": "Path 894",
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.553.432a1.611 1.611 0 011.622 0L28.75 5.88c1.827 1.039 1.21 4.333-.811 4.333H8.789c-2.022 0-2.638-3.294-.811-4.333z",
    className: "kpmg-clients-link_svg__cls-6",
    transform: "translate(112.109 149.787)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.364 1.814a.107.107 0 00-.02.009L8.769 7.27c-.267.151-.33.606-.237.958.043.16.15.384.257.384h19.15c.107 0 .214-.225.257-.384.093-.352.03-.807-.237-.958l-9.575-5.448a.106.106 0 00-.02-.01m0-1.6c.277 0 .554.073.811.22L28.75 5.88c1.827 1.04 1.21 4.333-.811 4.333H8.789c-2.022 0-2.638-3.294-.811-4.333L17.553.432c.256-.146.534-.219.811-.219z",
    transform: "translate(112.109 149.787)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-clients-link_svg__Ellipse_189",
    "data-name": "Ellipse 189",
    transform: "translate(127.973 153)",
    stroke: "#30acec",
    strokeWidth: 1.6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    className: "kpmg-clients-link_svg__cls-6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1.7,
    className: "kpmg-clients-link_svg__cls-7"
  })))));
}

export default SvgKpmgClientsLink;